<template>
	<div>
		<!-- <mainTop></mainTop> -->
		<div class="zsxqMiddleBox" style="margin-top: 150px;">
			<div class="zpDetail" style="position: relative;" v-if="product&&ap">
				<div class="zstpTitle" style="color: #150e52;text-align: center;">
					<span style="font-size: 36px;font-weight: 600;">{{ this.product.data.name }}</span>
					<span style="font-size: 18px;font-family: PingFangSC-Semibold, sans-serif;margin-left: 30px;">作者：{{  this.product.data.authorNameZZ  }}</span>
				</div>




			</div>
			<div class="zpDetailContent">
				<div class="zsCardBox21" v-if="img.length==1"
				   @mouseenter=""
				   @mouseleave="">
				   <div style="width: 500px;height: 500px;margin: auto;">
					   <img class="zstdImg" :src="baseUrl()+img[0]"  v-image-preview style="width: 100%;height: 100%;" alt="">
				   </div>

				 </div>
				 <div class="zsCardBox21" v-if="img.length==2"
				    @mouseenter=""
				    @mouseleave="">
				    <div style="display: inline-block;width: 500px;height: 500px;margin: auto;margin-right: 20px;">
						<img class="zstdImg" :src="baseUrl()+img[0]"  v-image-preview style="width: 100%;height: 100%;margin-right: 15px;" alt="">
					</div>
					<div style="display: inline-block;width: 500px;height: 500px;margin: auto;">
						<img class="zstdImg" :src="baseUrl()+img[1]"  v-image-preview style="width: 100%;height: 100%;" alt="">
					</div>
				  </div>
				<div class="zsCardBox2" v-if="img.length>=3"
				   @mouseenter=""
				   @mouseleave="">
				   <div class="swiper-button-prev swiper-button-prev2"></div>
				   <swiper ref="swiper"
				     :options="options">
				     <swiper-slide v-for="(item,index) in img"
				       :key="index">
				       <div class="zsCard2">
											<img v-image-preview :src="baseUrl()+item" alt="" style="width: 100%;height: 100%;width: 100%;">
				       </div>
				     </swiper-slide>
				   </swiper>
				   <div class="swiper-button-next swiper-button-next2"></div>
				 </div>
			</div>
			<div class="sjxx">
				<div style="color: #150e52;font-size: 24px;font-weight: 600;text-align: center;">
					作者介绍
				</div>
				<table class="sjColumn" style="word-wrap: break-word; word-break: break-all;">
					<tr>
						<td style="background-color: #eceaea;" class="columnName">
							地区
						</td>
						<!-- <td class="sjContent">{{ this.product.data.countryName?this.product.data.countryName:"中国" }}</td> -->
						<td class="sjContent">{{ this.product.data.address }}</td>
						<td style="background-color: #eceaea;" class="columnName">
							类型
						</td>
						<td class="sjContent">{{ this.product.data.nameProductionType }}</td>
					</tr>
					<tr>
						<td style="background-color: #eceaea;" class="columnName">
							作者
						</td>
						<td class="sjContent">{{ this.product.data.authorNameZZ }}</td>
						<td style="background-color: #eceaea;" class="columnName">
							联系方式
						</td>
						<td class="sjContent">{{ this.product.data.contact }}</td>
					</tr>
					<tr>
						<td style="background-color: #eceaea;" class="columnName">
							参展日期
						</td>
						<td class="sjContent">{{ this.product.data.showTime }}</td>
						<td style="background-color: #eceaea;" class="columnName">
							创作日期
						</td>
						<td class="sjContent">{{ this.product.data.creativeTime }}</td>
					</tr>
					<tr style="min-height: 400px;line-height: 50px;">
						<td colspan="4" style="min-height: 40px;font-size: 16px;padding: 0px 10px;">
							{{ this.product.data.synopsis }}
						</td>
					</tr>
				</table>
			</div>
			<div class="cpzx" v-if="ap.data">
				<div style="color: #150e52;font-size: 24px;font-weight: 600;text-align: center;">
					作品系列
				</div>

					<div class="cpzxContent" style="">
						<div class="zpzx_module" v-for="(item,index) in ap.data" :key="index">
							<router-link target="_blank" :to="{ path: '/zpDetail', query: { id: item.id} }" style="text-decoration: none;">
							<div><img :src="baseUrl()+item.fimg" alt="" style="width: 272px;height: 272px;z-index: 100;"></div>
							<div style="line-height: 60px;">
								<div style="text-align: center;color: #150e52;font-size: 18px;font-weight: 600;">{{ item.name }}</div>
							</div>
							</router-link>
						</div>
					</div>
			</div>
			<div style="width: 1140px;min-width: 1140px;margin: auto;margin-top: 38px;margin-bottom: 35px; height: 40px;">
				<div style="height: 60px;float: right;">
						 <el-pagination
						      @size-change="handleSizeChange"
						      @current-change="handleCurrentChange"
						      :current-page.sync="currentPage"
						      :page-size="9"
						      layout="prev, pager, next"
						      :total="this.total">
						    </el-pagination>
							<div class="el-pagination__jump">
								共{{totalPageSize}}页，到第<div class="el-input el-pagination__editor is-in-pagination">
									<input type="text" class="inputNum" v-model="pageInputNum"
									oninput="value=value.replace(/[^\d]/g,'');
									if(value<=0)value='';if(value.length > 1 && value.substr(0,1) ==0 && value.substr(1,1) !='.'){
									value= value.substr(1,1)}" >
							</div>
							页
							</div>

						<button class="button1" style=""  @click="changePage">确定</button>
				</div>
			</div>
		</div>
		<!-- <mainBottom></mainBottom> -->
	</div>
</template>

<script>
	import 'swiper/css/swiper.css'
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import mainTop from '../components/mainTop.vue'
	import mainBottom from '../components/mainBottom.vue'
	import axios from 'axios'
  import {baseUrl} from "@/components";
	export default {
	  components: {
		  mainTop,
		  mainBottom,
		  Swiper,
		  SwiperSlide,
	   },
	   data(){
			return{
				 options: {
				        pagination: {
				          el: ".case-swiper-pagination"
				          //区分不同Swiper的组件
				        },
				        //显示分页
				        loop: true,
				        //开启循环
				        loopedSlides: 6,
				        //设置平滑
				        slidesPerView: 3,
						 spaceBetween:25,
				        //设置能够同时显示的数量（可设置 auto）
				        speed: 1000,
				        //切换速度

				        navigation: {
				          prevEl: ".swiper-button-prev2",
				          nextEl: ".swiper-button-next2"
				        },
				        //左右箭头按钮(可自定义)

				        // autoplay: false,
				        //是否开启自动轮播

				        autoplay: {
				          delay: 3000,
				          stopOnLastSlide: false,
				          disableOnInteraction: false
				        },
				        // 开启自动轮播后，设置自动轮播的延迟时间
				        loopAdditionalSlides: 1,
				        //复制若干个slide
				        // slidesPerGroup: 3,
				        // 定义slides的数量多少为一组，即每次切换slides的数量，默认每次切换一张
				        on: {
				          slideChangeTransitionEnd: function() {
				            // console.log(this.activeIndex);
				            //获取当前下标，切换结束时，告诉我现在是第几个slide
				          }
				        }
				      },
				pageSize: 16,
				totalCount: 1,
				totalPageSize:1,
				pageInputNum:'',
				currentPage: 1,
				videos:'',
				total:5,
				product:'',
				ap:'',
				id:0,
				img:'',

			};
	   },
	   created(){
			this.getProduct();
      this.getIp();
	   },
		methods:{
      baseUrl,
      getIp(){
        axios.get('https://api.ipify.org?format=json').then((res)=>{
          this.ipAddress=res.data.ip
          // console.log(res.data.ip)
          this.viewPost(this.ipAddress)
        })
      },
      viewPost(ipAddress){
        axios.post('/web/view',{
          viewType:6,
          viewIp:ipAddress,
          viewId:this.$route.query.id,
          viewTime:Date.now(),
        }).then((res)=>{

        })
      },
			getProduct(){
				axios.get('/web/production/'+ this.$route.query.id ).then((res)=>{
                    this.product=res.data
					this.img=this.product.data.img.split(",")
					this.getAP(this.product.data.authorName)
					// console.log(this.product);
                })
			},
			getAP(id){
				axios.get('/web/production/other/'+ id ).then((res)=>{
                    this.ap=res.data
					for (let index = 0; index < this.ap.data.length; index++) {
						let firstimg=''
						firstimg=this.ap.data[index].img.split(",")
						this.ap.data[index].fimg=firstimg[0]
					}
					// console.log(this.ap.data[0].fimg);
                })
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange() {
			//    this.contentPerPage.pn=this.currentPage;
			//    contentList(this.contentPerPage).then(response => {
			//            this.contentPerPageList = response.data;
			//          });
			},
			changeFirstPage(){
				this.currentPage=1;
				this.handleCurrentChange();
			},
			changeLastPage(){
				this.currentPage=this.totalPageSize;
				this.handleCurrentChange();
			},
			getTotalPageSize(){
				this.totalPageSize=this.totalCount/this.pageSize
			},
			changePage(){
				this.currentPage=this.pageInputNum;
				this.handleCurrentChange();
			},
		},
		 computed: {
		    swiper() {
		      return this.$refs.swiper.$swiper;
		    }
		  },
		}
</script>
<style scoped>

</style>
<style>

	.vue-directive-image-previewer-img{
		position: relative !important;
		margin: auto;
		width: 700px !important;
		height: 700px !important;
		top: 0px;
		left: 0px !important;
	}
	.vue-directive-image-previewer-body{
		text-align: center;
	}
	.zsCardBox21 {
	    margin: auto;
	    text-align: center;
	    padding: 24px 0px;

	}
	.zsxqMiddleBox{
		width: 100%;
		min-width: 1700px;
		background-color: #f6f6f6;
	}
	.zpDetail{
		width: 1140px;
		min-width: 1140px;
		height: auto;
		margin: auto;
		margin-top: 45px;
	}
	.zpDetailContent{
		width: 100%;
		min-width: 1700px;
		background-image: url('../images/zpBg.png');
		background-size: 100% 100%;
		height: auto;
		margin: auto;
		margin-top: 45px;
	}
	.zsCardBox2 {
	  width: 1025px;
	  margin: 0 auto;
	  position: relative;
	  margin-top: 45px;
	  padding: 20px 0px;
	}
	.zsCard2 {
	    width: 325px;
	    height: 410px;

	    position: relative;
	    cursor: pointer;
	  }
	  .zsCardBox2 .swiper-slide {
	      transform: scale(1) !important;
	      width: 325px !important;
	      height: 410px !important;
	  }
	  .zsCardBox2 .swiper-button-prev{
		  left: -57px !important;
		  top: 50%;
		  background-color: #494478;
		  width: 37px;
		  height: 37px;
		  border-radius: 50%;
	  }
	  .zsCardBox2 .swiper-button-next{
	  	right: -57px !important;
		top: 50%;
		background-color: #494478;
		width: 37px;
		height: 37px;
		border-radius: 50%;
		text-align: center;
	  }
	  .zsCardBox2 .swiper-button-prev:after,.zsCardBox2 .swiper-button-next:after {
	      font-size: 21px;
		  color: #fff;
	  }
	  .sjxx{
		width: 1140px;
		min-width: 1140px;
		height: auto;
		margin: auto;
		margin-top: 45px;
	  }
	  .sjColumn{
	  	width: 100%;
	  	color: #150e52;
	  	border-collapse: collapse;
	  	border: 2px solid #eceaea;
	  	margin-top: 25px;
	  }
	  .sjColumn>tr>td{
	  	border-bottom: 2px solid #eceaea;
	  }
	  .columnName{
	  	width: 150px;
	  	/* min-height: 71px; */
	  	background-color: #eceaea;
	  	font-size: 18px;
	  	text-align: center;
	  	line-height: 70px;
		font-weight: 600;
	  }
	  .sjContent{
		  width: 440px;
		  padding-left: 50px;
		  font-size: 18px;
	  }
	  .cpzx{
	  		width: 1140px;
	  		min-width: 1140px;
	  		height: auto;
	  		margin: auto;
	  		margin-top: 30px;
	  }
	  .zpzx_module{
	  	width: 272px;
	  	height: 334px;
	  	background-color: #fff;
	  	display: inline-block;
	  	margin-right: 17px;
	  	margin-top: 17px;
	  	overflow: hidden;
	  	position: relative;
	  	transition: all .2s;
	  }
	  .zpzx_module:hover .fg4,.zpzx_moduleRight:hover .fg4{
	  	left: 110%;
	  	transition: all .1s;
	  }
	  .fg4{
	  	position: absolute;
	  	left: -110%;
	  	top: 0;
	  	width: 593px;
	  	height: 340px;
	  	background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));
	  	transform: skew(-30deg);
	  }
	  .cpzx_moduleTitle{

	  }
	  .cpzxContent{
	  	margin-top: 22px;
	  }
	  .zpzx_module:nth-child(4n){
	  	width: 272px;
	  	height: 334px;
	  	background-color: #fff;
	  	display: inline-block;
	  	margin-top: 17px;
	  	overflow: hidden;
	  	position: relative;
	  	transition: all .2s;
		margin-right: 0px !important;
	  }
</style>
